export default __webpack_public_path__ + "static/media/akm.48ae7efb.png";